import request from '@/utils/request'

// 采购报表
export function fetchList(params) {
    return request({
        url: '/report/qc',
        method: 'get',
        params: params
    })
}


// WEBPACK FOOTER //
// ./src/api/scm/quality.js